<template>
    <div id="notification" class="fixed z-[100]">
        <div @click="handleHide" ref="notificationBlock" :class="{'top-4': enter, 'top-[-100px]': !enter, 'max-w-[35rem] min-w-[20rem] right-[2rem]': !isMobileVersion, 'w-auto right-4 left-4': isMobileVersion}" class="shadow-md shadow-custom-blue border bg-white border-custom-blue rounded duration-1000 z-[100] fixed transition-all px-4">
            <p ref="notificationContent" class="rounded-lg px-4 py-2 text-center dark:text-white dark:bg-gray-600">{{ message }}</p>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "MainNotification",
        computed: {
            ...mapState("authentication", ["isMobileVersion"]),
        },
        data() {
            return {
                enter: false,
                message: "",
                timeoutId: null,
            }
        },
        methods: {
            show(newMessage, color, duration) {
                const notificationContent = this.$refs.notificationContent;
                notificationContent.style.color = color;

                if (this.enter) {
                    this.enter = false;
                    clearTimeout(this.timeoutId);
                    this.timeoutId = null;
                    setTimeout(() => {this._openNotification(newMessage, duration)}, 300);
                } else {
                    this._openNotification(newMessage, duration);
                }
            },
            _openNotification(newMessage, duration) {
                this.message = newMessage;
                this.enter = true;
                if (duration !== Infinity) this.timeoutId = setTimeout(this.hide, duration);
            },
            handleHide() {
                if (this.timeoutId) clearTimeout(this.timeoutId);
                this.hide();
            },
            hide() {
                this.enter = false;
            },
        },
    }
</script>